import React from "react";
import styled from "styled-components";

export const Header = styled.header<{ background?: string }>`
  grid-area: HD;
  display: flex;
  width: 100vw;
  height: 56px;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => (props.background ? props.background : "none")};
`;

// export const Header = styled.header`
//   grid-area: HD;
//   display: flex;
//   width: 100vw;
//   height: 56px;
//   padding: 0 16px;
//   align-items: center;
// `;

export const HeaderTit = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
`;

export const MoreHeader = styled.header<any>`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const BackBtnBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 12px;
  font-size: 1.6rem;
  color: ${(props) => props.theme.colors.primary};
`;

export const MoreHeaderTit = styled.p`
  width: 100%;
  font-size: 1.8rem;
  font-weight: 900;
`;

export const MoreHeaderIcon = styled.div`
  position: absolute;
  top: 0;
  right: 16px;
`;

export const MoreHeaderActionButton = styled.button`
  position: absolute;
  top: 0;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.3rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  padding: 8px 8px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  background-color: ${(props) => props.theme.colors.mainBg};

  &:hover {
    background-color: ${(props) => props.theme.colors.primary}20;
  }

  &:active {
    background-color: ${(props) => props.theme.colors.primary}40;
  }
`;
